import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Después de aplicar el Protocolo de Crisis del Tomo 2, la última vez que mi hijo tuvo una convulsión supe exactamente qué hacer. No entré en pánico, lo puse en posición de seguridad, cronometré y llamé al médico con información clara. El neurólogo me felicitó por cómo lo manejé.',
  name: 'Verónica M.',
  location: 'Gran Buenos Aires',
  role: 'Mamá de Matías, 7 años, epilepsia diagnosticada desde los 3'
}, {
  quote: 'El Bono del Diario de Convulsiones cambió todo. Cuando llegué a la consulta con 3 meses de registros detallados, el neurólogo pudo ajustar la medicación de una forma que en 2 años nunca había podido. Las crisis bajaron un 60% en 6 semanas.',
  name: 'Luciana P.',
  location: 'Córdoba',
  role: 'Mamá de Valentín, 9 años, epilepsia focal'
}, {
  quote: 'El Tomo de Alimentación me abrió los ojos. Cambié el desayuno y eliminé los ultraprocesados. No puedo probar que sea solo eso, pero hace 3 meses que no tiene crisis nocturnas. Antes las tenía cada 15 días.',
  name: 'Marcela R.',
  location: 'Rosario',
  role: 'Mamá de Camila, 5 años, lleva 2 años con epilepsia'
}];
export const Testimonials = () => {
  return <section className="py-10 sm:py-14 md:py-16 bg-white" data-id="element-263">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-264">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6 md:gap-8" data-id="element-265">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} whileHover={{
          y: -4,
          transition: {
            duration: 0.2
          }
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.35,
          delay: i * 0.1
        }} className="bg-cream-dark p-5 sm:p-6 md:p-8 rounded-2xl shadow-card border border-brand-orange/10 relative cursor-default" data-id="element-266">
              <div className="flex gap-1 mb-3 sm:mb-4" data-id="element-267">
                {[...Array(5)].map((_, j) => <Star key={j} size={16} className="text-brand-gold fill-brand-gold" data-id="element-268" />)}
              </div>
              <p className="text-gray-700 italic mb-4 sm:mb-6 leading-relaxed text-sm sm:text-base" data-id="element-269">
                "{t.quote}"
              </p>
              <div data-id="element-270">
                <p className="font-bold text-gray-900 text-sm sm:text-base" data-id="element-271">
                  {t.name}{' '}
                  <span className="text-brand-orange font-normal" data-id="element-272">
                    — {t.location}
                  </span>
                </p>
                <p className="text-xs sm:text-sm text-gray-500 mt-1" data-id="element-273">
                  {t.role}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};